import type { FormInstance } from 'antd';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

const isValidNumber = (v: unknown): boolean => v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v));

export const validateMeasures = (form: FormInstance) => () => ({
  validator: async () => {
    const length = form.getFieldValue('length');
    const width = form.getFieldValue('width');
    const height = form.getFieldValue('height');
    const cube = form.getFieldValue('cube');

    const hasLWH = isValidNumber(length) && isValidNumber(width) && isValidNumber(height);
    const hasCube = isValidNumber(cube);

    if (!hasLWH && !hasCube) {
      showNotification({
        message: 'Please enter either full Length, Width, Height or a Cube value',
        toastId: 'dim-validation-error',
        type: NOTIFICATION_TYPES.ERROR,
      });

      return Promise.reject('');
    }

    return Promise.resolve();
  },
});
